import { parse, stringify } from 'flatted';
import { JsonEditor } from '../JsonEditor';
import { useConversation } from 'hooks/conversation';
import { createCallback } from '../utils';

export const ConversationDebug = () => {
  const { conversationState, dispatchConversationAction } = useConversation();
  const nonCircularConversationState = parse(stringify(conversationState), (key, value) => {
    if (key === 'twilio')
      return parse(stringify(value, (key1, value2) => (key1.startsWith('_') ? undefined : value2)));
    return value;
  });

  return (
    <JsonEditor
      {...createCallback(dispatchConversationAction)}
      rootName='Conversation*'
      data={nonCircularConversationState}
    />
  );
};
